const cards = [
  {
    seq: 'card-01',
    title: '某女星被拍到深夜出入整形医院，网友：这是第几次了',
    desc: '连续三天被拍到出入同一家整形机构，引发网友热议。究竟是日常保养还是有新项目？我们对比了她近三年的颜值变化...',
    tag: '娱乐圈',
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20news%20dramatic%20visual%2C%20paparazzi%20style%20night%20scene%2C%20warm%20coral%20lighting%2C%20entertainment%20gossip%20theme%2C%20modern%20tabloid%20aesthetic%2C%20eye-catching%20headline%20composition&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    seq: 'card-02',
    title: '某带货主播被曝数据造假，品牌方集体维权索赔',
    desc: '直播带货数据水分到底有多大？一位头部主播的翻车事件揭开了行业遮羞布。多个品牌已联合发起维权，索赔金额或超亿元...',
    tag: '电商内幕',
    image: 'https://readdy.ai/api/search-image?query=Livestream%20ecommerce%20scandal%20visual%2C%20data%20fraud%20theme%2C%20modern%20studio%20lighting%2C%20warm%20amber%20and%20coral%20tones%2C%20dramatic%20news%20graphic%20style%2C%20social%20media%20controversy%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    seq: 'card-03',
    title: '知名导演新片选角引争议，被质疑"审美倒退二十年"',
    desc: '大导演的新片选角名单流出后引发全网群嘲。网友翻出其二十年来所有作品女主对比，质疑其审美标准出现严重偏差...',
    tag: '影视圈',
    image: 'https://readdy.ai/api/search-image?query=Film%20casting%20controversy%20visual%2C%20movie%20director%20theme%2C%20dramatic%20lighting%20cinematic%20style%2C%20warm%20orange%20and%20coral%20palette%2C%20entertainment%20industry%20graphic%2C%20bold%20headline%20design&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    seq: 'card-04',
    title: '综艺节目剪辑师匿名爆料：一段"名场面"是怎么造出来的',
    desc: '你看到的每一个泪点、每一个冲突、每一个反转，可能都来自剪辑师的剪刀。从业十年剪辑师独家揭秘综艺后期制作的内幕操作...',
    tag: '独家揭秘',
    image: 'https://readdy.ai/api/search-image?query=Video%20editing%20studio%20behind%20scenes%2C%20TV%20production%20theme%2C%20dark%20mysterious%20atmosphere%20with%20warm%20accents%2C%20professional%20editing%20suite%2C%20dramatic%20lighting%2C%20entertainment%20industry%20reveal&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    seq: 'card-05',
    title: '某男团成员被爆私联粉丝，经纪公司发声明否认又秒删',
    desc: '深夜有粉丝放出多张聊天截图实锤偶像私联，公司凌晨发声明后又火速删除，这一迷之操作让事件变得更加扑朔迷离...',
    tag: '偶像圈',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20idol%20scandal%20visual%2C%20fan%20controversy%20theme%2C%20dramatic%20stage%20lighting%2C%20warm%20coral%20and%20amber%20tones%2C%20entertainment%20gossip%20graphic%20style%2C%20breaking%20news%20aesthetic&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    seq: 'card-06',
    title: '娱乐圈"星二代"扎堆出道：拼爹还是真有实力',
    desc: '今年已有超过15位星二代官宣出道，资源好到让人眼红。我们盘点了近五年星二代的出道成绩单，看看谁是真有实力，谁是纯靠爹妈...',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20family%20theme%2C%20star%20kids%20debut%20visual%2C%20red%20carpet%20aesthetic%2C%20warm%20coral%20and%20amber%20palette%2C%20entertainment%20industry%20graphic%2C%20spotlight%20composition&width=800&height=500&seq=card-06&orientation=landscape',
  },
  {
    seq: 'card-07',
    title: '某热播剧原著作者手撕剧组：改编得面目全非',
    desc: '又一例原著与改编翻车！作者连发十条长文怒斥剧组不尊重原作，粉丝分成两派激烈互撕。究竟是作者玻璃心还是剧组确实离谱...',
    tag: '影视吐槽',
    image: 'https://readdy.ai/api/search-image?query=TV%20drama%20adaptation%20controversy%20visual%2C%20author%20versus%20production%20theme%2C%20dramatic%20conflict%20aesthetic%2C%20warm%20amber%20and%20coral%20tones%2C%20entertainment%20news%20graphic%2C%20bold%20headline%20design&width=800&height=500&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-bold mb-4">
            <i className="ri-article-line"></i>
            精选内容
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            编辑精选推荐
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            深度好文与独家爆料，编辑团队为你精选的优质吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 6).map((c) => (
            <a
              key={c.seq}
              href="#cards"
              className="group block bg-background-50 rounded-xl overflow-hidden hover:shadow-md transition-all duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={c.image}
                  alt={`51吃瓜在线精选-${c.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`51吃瓜在线内容-${c.title}`}
                />
                <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-bold">
                  {c.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {c.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {c.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        {cards.length === 7 && (
          <div className="mt-5">
            <a
              href="#cards"
              className="group block bg-background-50 rounded-xl overflow-hidden hover:shadow-md transition-all duration-300"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative sm:w-[300px] flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden bg-background-200">
                  <img
                    src={cards[6].image}
                    alt={`51吃瓜在线精选-${cards[6].title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    title={`51吃瓜在线内容-${cards[6].title}`}
                  />
                  <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-bold">
                    {cards[6].tag}
                  </span>
                </div>
                <div className="p-5 flex-1 flex flex-col justify-center">
                  <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {cards[6].title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {cards[6].desc}
                  </p>
                </div>
              </div>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}